import '../style/divider-DGpUplT0.css'
import { defineComponent as i, openBlock as o, createElementBlock as t, normalizeClass as r, renderSlot as n, createCommentVNode as a } from "vue";
const d = ["aria-orientation"], s = {
  key: 0,
  class: "e-divider-content"
}, p = /* @__PURE__ */ i({
  name: "e-divider",
  __name: "divider",
  props: {
    orientation: { default: "horizontal" }
  },
  setup(l) {
    return (e, c) => (o(), t("div", {
      role: "separator",
      class: r([
        "e-divider",
        "e-divider--" + e.orientation
      ]),
      "aria-orientation": e.orientation
    }, [
      e.$slots.default ? (o(), t("div", s, [
        n(e.$slots, "default")
      ])) : a("", !0)
    ], 10, d));
  }
});
export {
  p as default
};
//# sourceMappingURL=divider.js.map
